export default __webpack_public_path__ + "static/media/beforeProfile.06d3026a.jpg";